<template>
  <div class="col-12 card-collapse">
    <div class="card">
      <div class="card-header">{{ t('Attachments') }}</div>
      <div class="card-body row">
        <div class="col-6">
          <file-upload-with-encryption
            @addedFile="loadAttachmentsData()"
            :multiple="true"
            :api-url="uploadEncryptedFileUrl"
            :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"
          />
          <div class="mt-2" v-if="applicationsAttachments.length === 0">
            {{ t('Files were not attached to applications') }}
          </div>
        </div>
        <div class="col-6">
          <a :href="file.link"
            :key="file.id"
            :download="file.isClientEncrypted ? file.decryptedFilename : file.file"
            v-for="file in applicationsAttachments"
            class="row file-row"
            target="_blank"
          >
            <div class="col col-lg-2 file-col-image">
              <img :src="file.link" :alt="file.file"
                v-if="['jpg', 'png', 'gif'].includes(file.format)">
              <div class="file-icon" v-if="!(['jpg', 'png', 'gif'].includes(file.format))">
                <font-awesome-icon icon="file"/>
              </div>
            </div>
            <div class="col col-lg-10">
              <div class="h3 mb-0">{{ file.isClientEncrypted ? file.decryptedFilename : file.name }}</div>
              <small>{{ file.size | prettyBytes }}</small>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FileUploadWithEncryption from './file-upload-with-encryption'
  import { apiLink } from '../../../store/api'

  export default {
    components: {
      FileUploadWithEncryption,
    },
    name: 'attachments',
    props: {
      applicationsAttachments: {
        type: Array,
        required: true
      }
    },
    computed: {
      uploadEncryptedFileUrl() {
        return apiLink() + 'applications/upload-file-encrypted/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
      },
    },
    methods: {
      loadAttachmentsData() {
        this.$store.dispatch('applications/attachments', this.$route.params.id);
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/private/applications/attachments.vue